import idb from '@/store/services/idb';
import { WsCalls } from '@/store/services/wsCalls';
import router from '../../router/index.js';
import { v7 as uuidv7 } from 'uuid';

// initial state
const state = () => ({
  firstLoad: false,
  selectedStore: 0,
  storeConfig: null,
  tabs: [],
  containers: [],
  banners: [],
  carousel_banners: [],
  cities: [],
  stores: [],
  poupometro: 0,
  apps: {
    ios: '',
    android: ''
  },
  isCep: false,
  payments: [],
  online_payments: [],
  storePickup: [],
  genders: [
    {
      id: 0,
      descricao: "Masculino"
    },
    {
      id: 1,
      descricao: "Feminino"
    },
    {
      id: 2,
      descricao: "Outro"
    }
  ],
  estados: [
    {
      sigla: "AC",
      descricao: "Acre"
    },
    {
      sigla: "AL",
      descricao: "Alagoas"
    },
    {
      sigla: "AP",
      descricao: "Amapá"
    },
    {
      sigla: "AM",
      descricao: "Amazonas"
    },
    {
      sigla: "BA",
      descricao: "Bahia"
    },
    {
      sigla: "CE",
      descricao: "Ceará"
    },
    {
      sigla: "DF",
      descricao: "Distrito Federal"
    },
    {
      sigla: "ES",
      descricao: "Espírito Santo"
    },
    {
      sigla: "GO",
      descricao: "Goiás"
    },
    {
      sigla: "MA",
      descricao: "Maranhão"
    },
    {
      sigla: "MT",
      descricao: "Mato Grosso"
    },
    {
      sigla: "MS",
      descricao: "Mato Grosso do Sul"
    },
    {
      sigla: "MG",
      descricao: "Minas Gerais"
    },
    {
      sigla: "PA",
      descricao: "Pará"
    },
    {
      sigla: "PB",
      descricao: "Paraíba"
    },
    {
      sigla: "PR",
      descricao: "Paraná"
    },
    {
      sigla: "PE",
      descricao: "Pernambuco"
    },
    {
      sigla: "PI",
      descricao: "Piauí"
    },
    {
      sigla: "RJ",
      descricao: "Rio de Janeiro"
    },
    {
      sigla: "RN",
      descricao: "Rio Grande do Norte"
    },
    {
      sigla: "RS",
      descricao: "Rio Grande do Sul"
    },
    {
      sigla: "RO",
      descricao: "Rondônia"
    },
    {
      sigla: "RR",
      descricao: "Roraima"
    },
    {
      sigla: "SC",
      descricao: "Santa Catarina"
    },
    {
      sigla: "SP",
      descricao: "São Paulo"
    },
    {
      sigla: "SE",
      descricao: "Sergipe"
    },
    {
      sigla: "TO",
      descricao: "Tocantins"
    },
  ],
  loadingTabs: true,
  loadingSubCategories: true,
  loadingBanners: 0,
  loadingFixedBanners: true,
  loadingStores: true,
  loadingText: true,
  loadingFooter: true,
  loadingPoupometro: true,
  loadingContainers: true,
  logoImage: null,
  storeImage: null
})

// getters
const getters = {
  getConfig: (state, rootGetters, rootState) => {
    let config = {
      store: state.selectedStore,
      isu: rootState.user.isu,
      storeConfig: state.storeConfig
    }
    return config;
  },
  getCategories: (state) => (caracteresLimit = 9999) => {
    var caracteresMenu = 0;
    var categoriesMenu = [];
    let categories = state.tabs.filter(category => category.type == 3);
    if (categories != undefined) {
      categories.forEach(function (element) {
        if ((caracteresMenu + element.name.length) <= caracteresLimit) {
          caracteresMenu = caracteresMenu + element.name.length;
          categoriesMenu.push(element);
        }
      });
      return categoriesMenu;
    } else {
      return []
    }
  },
  getCategoriesLimit: (state) => (qtdLimit) => {
    let categories = state.tabs.filter(category => category.type == 3);
    if (qtdLimit && categories != undefined) {
      return categories.slice(0, qtdLimit);
    } else {
      return categories;
    }
  },
  getCategoryById: (state) => (id) => {
    let categories = state.tabs.filter(category => category.type == 3);
    if (categories != undefined) {
      return categories.find(category => category.id == id);
    } else {
      return undefined;
    }
  },
  getCategoryCarrossel: (state) => (i) => {
    let categories = state.tabs.filter(category => category.type == 3);
    if (categories != undefined) {
      return categories[i];
    } else {
      return [];
    }
  },
  getSubCategories: (state) => (id) => {
    let categories = state.tabs.filter(category => category.type == 3);
    if (categories != undefined) {
      return categories.find(category => category.id == id).subcategories;
    } else {
      return [];
    }
  },
  getSubCategoryById: (state) => (id_category, id) => {
    let categories = state.tabs.filter(category => category.id == id_category && category.type == 3);
    if (categories != undefined) {
      if (categories[0].subcategories != undefined) {
        categories = categories[0].subcategories.find(subcategory => subcategory.id_subcategoria == id);
        return categories != undefined ? categories.nome_subcategoria : "";
      } else {
        return "";
      }
    } else {
      return "";
    }
  },
  getBannersHome: (state) => {
    return state.banners;
  },
  getCarouselBanners: (state) => {
    let banners = state.carousel_banners.filter(i => i.image != undefined && i.image != 'no-image');
    return banners == null ? []: banners;
  },
  getPayments: (state) => (index) => {
    if (index == undefined) {
      return state.payments;
    } else {
      return state.payments.slice(index, index + 8);
    }
  },
  getPaymentOnline: (state) => {
    return state.online_payments;
  },
  getPaymentById: (state) => (id) => {
    return state.payments.find(payment => payment.id == id);
  },
  getPaymentOnlineById: (state) => (id) => {
    let payments = state.online_payments.find(payment => payment.id == id);
    return payments != undefined ? payments : { name: "", image: "" };
  },
  getTabs: (state) => {
    let tabs = null;
    if(state.storeConfig != null && state.storeConfig.is_ordertab == 1){
      tabs = state.tabs.filter(tab => tab.type != 3 && tab.type != 1);
      tabs.sort((a,b) => b.type - a.type);
      let offers = state.tabs.find(tab => tab.type == 1);
      let mercadologicos = state.tabs.filter(tab => tab.type == 3);
      if(offers != undefined && offers != null){
        tabs.unshift(offers);
      }
      if(mercadologicos != undefined && mercadologicos != null){
        tabs = tabs.concat(mercadologicos);
      }
    } else {
      tabs = state.tabs;
    }
    return tabs;
  },
  getCities: (state) => {
    return state.cities;
  },
  getStores: (state) => {
    return state.stores;
  },
  getTabById: (state) => (type, id) => {
    let tabs = state.tabs.filter(tab => tab.type == type);
    return tabs.find(tab => tab.id == id);
  },
  getContainers: (state) => (i) => {
    return state.containers[i];
  },
  getTabsClusterOffers: (state) => {
    let tabs = null;
    if(state.storeConfig != null && state.storeConfig.is_ordertab == 1){
      tabs = state.tabs.filter(tab => tab.type != 3 && tab.type != 1);
      tabs.sort((a,b) => b.type - a.type);
      let offers = state.tabs.find(tab => tab.type == 1);
      if(offers != undefined && offers != null){
        tabs.unshift(offers);
      }
    } else {
      tabs = state.tabs.filter(tab => tab.type != 3);
    }
    return tabs;
  },
  getAllStorePickup: (state) => {
    return state.storePickup;
  },
  getPoupometro: (state) => {
    return state.poupometro;
  },
  checkModules: (state) => (module) => {
    if (state.storeConfig != null) {
      return state.storeConfig.modules.find(m => m == module);
    } else {
      return null;
    }
  }
}

// actions
const actions = {
  async setConfig({ commit, dispatch, state }) {
    let config = await idb.getData('config');
    return new Promise((resolve, reject) => {
      if (state.firstLoad == false) {
        dispatch('setVisit');
        if (config == undefined || config.length == 0) {
          dispatch('loadCities').then(function (response) {
            if(response != null && response.length == 1){
              dispatch('loadStores', response[0].city).then(function (response) {
                if(response != null && response.length == 1){
                  dispatch('setConfigStep2', [ { selectedStore: response[0].id, isu: 0 } ]).then(function (response) {
                    resolve(response);
                  }).catch(() => {
                    commit('setLogoImage', 'no-image' );
                    reject();
                  });
                } else if(response != null && response.length > 1) {
                  resolve(false);
                } else {
                  commit('setLogoImage', 'no-image' );
                  reject();
                }
              });
            } else if(response != null && response.length > 1) {
              resolve(false);
            } else {
              commit('setLogoImage', 'no-image' );
              reject();
            }
          });
        } else {
          dispatch('setConfigStep2', config).then(function (response) {
            resolve(response);
          }).catch(() => {
            resolve(false);
          });
        }
      } else {
        resolve(true);
      }
    });
  },
  async setConfigStep2({ commit, dispatch, rootGetters }, config) {
    return new Promise((resolve, reject) => {
      commit('setSelectedStore', config[0].selectedStore);
      let cof = rootGetters['main/getConfig'];
      cof.isu = config[0].isu;
      
      WsCalls.callMethodWS('GET', 'init', cof).then(function (response) {
        if (response.data.cod == 100 && response.data.return) {
          commit('setStoreConfig', response.data.return);
          try {
            document.getElementById('sessionid').value = "";
            if(response.data.return.clearsale_fingerprint != ''){
              (function (a, b, c, d, e, f, g) {
                a['CsdpObject'] = e; a[e] = a[e] || function () {
                (a[e].q = a[e].q || []).push(arguments)
                }, a[e].l = 1 * new Date(); f = b.createElement(c),
                g = b.getElementsByTagName(c)[0]; f.async = 1; f.src = d; g.parentNode.insertBefore(f, g)
                })(window, document, 'script', '//device.clearsale.com.br/p/fp.js', 'csdp');
              csdp('app', response.data.return.clearsale_fingerprint);
              csdp('outputsessionid', 'sessionid');
            }
          } catch(e){
            console.log(e);
          }
          if(response.data.return.imghash_group != null){
            WsCalls.callMethodWS('IMAGE', 'logoImage', rootGetters['main/getConfig'], response.data.return.imghash_group).then(async function (retorno) {
              if (retorno.data.cod == 404) {
                commit('setLogoImage', 'no-image' );
              } else {
                commit('setLogoImage', URL.createObjectURL(retorno.data) );
              }
            });
          } else {
            commit('setLogoImage', 'no-image' );
          }
          if(response.data.return.imghash_store != null){
            WsCalls.callMethodWS('IMAGE', 'servicesImage', rootGetters['main/getConfig'], response.data.return.imghash_store).then(async function (retorno) {
              if (retorno.data.cod == 404) {
                commit('setStoreImage', 'no-image' );
              } else {
                commit('setStoreImage', URL.createObjectURL(retorno.data) );
              }
            });
          } else {
            commit('setStoreImage', 'no-image' );
          }
          dispatch('buscas/getBuscas', null, { root: true });
          if(response.data.return.modules.find(m => m == 2)){
            dispatch('user/updateIsu', config[0].isu, { root: true }).then(function () {
              commit('setFirstLoad', true);
              dispatch('live');
              resolve(true);
            });
          } else {
            commit('setSelectedStore', 0);
            reject();
          }
        } else {
          commit('setSelectedStore', 0);
          reject();
        }
      }).catch(() => {
        router.push("/erro");
      });
    });
  },
  generateVisitHash() {
    const hash = uuidv7();
    localStorage.setItem('visit_hash', hash);
    return hash;
  },
  async setVisit({ rootGetters}, {preExisting = false, regenerateHash = false } = {}) {
    let visitHash = localStorage.getItem('visit_hash');
    let generatedHash = false;

    if (!visitHash || regenerateHash) {
      visitHash = actions.generateVisitHash();
      generatedHash = true;
    }

    if (generatedHash || preExisting) {
      return new Promise((resolve) => {
        WsCalls.callMethodWS('POST', 'visits', rootGetters['main/getConfig'], {
          "visit_hash": visitHash,
          "preexisting": preExisting ? 1 : 0,
        }).then(function () {
          resolve(true);
        });
      });
    }
  },
  async setSelectedStore({ commit, dispatch }, selectedStore) {
    commit('setSelectedStore', selectedStore);
    await dispatch('updateConfig');
  },
  async updateConfig({ state, rootState }) {
    await idb.loadData('config', {
      "selectedStore": state.selectedStore,
      "isu": rootState.user.isu
    }, true);
  },
  async getPolicy({ commit, rootGetters }, id) {
    commit('setLoadingText', true);
    return new Promise((resolve) => {
      WsCalls.callMethodWS('GET', 'policy', rootGetters['main/getConfig'], id).then(function (response) {
        commit('setLoadingText', false);
        if (response.data.cod == 100 && response.data.return) {
          resolve(response.data.return);
        } else {
          resolve("");
        }
      });
    });
  },
  async getFooter({ rootGetters, commit }) {
    commit('setLoadingFooter', true);
    return new Promise((resolve, reject) => {
      WsCalls.callMethodWS('GET', 'footer', rootGetters['main/getConfig']).then(function (response) {
        if (response.data.cod == 100 && response.data.return) {
          commit('setPayments', response.data.return.payment_methods);
          response.data.return.payment_methods.forEach(element => {
            WsCalls.callMethodWS('IMAGE', 'paymentMethodImage', rootGetters['main/getConfig'], element.id).then(async function (retorno) {
              if (retorno.data.cod == 404) {
                commit('setPaymentImage', { id: element.id, image: 'no-image' });
              } else {
                commit('setPaymentImage', { id: element.id, image: URL.createObjectURL(retorno.data) });
              }
            });
          });
          commit('setLoadingFooter', false);
          resolve(response.data.return.footer);
        } else {
          commit('setLoadingFooter', false);
          reject();
        }
      });
    });
  },
  async loadCities({ commit, rootGetters }) {
    return new Promise((resolve) => {
      WsCalls.callMethodWS('GET', 'storeCity', rootGetters['main/getConfig'], "city").then(function (response) {
        if (response.data.cod == 100 && response.data.return) {
          commit('setCities', response.data.return);
          resolve(response.data.return);
        } else {
          resolve(null);
        }
      });
    });
  },
  async loadStores({ commit, rootGetters }, city) {
    commit('setStores', []);
    return new Promise((resolve) => {
      WsCalls.callMethodWS('GET', 'storeCity', rootGetters['main/getConfig'], "city/" + city).then(function (response) {
        if (response.data.cod == 100 && response.data.return) {
          commit('setStores', response.data.return);
          resolve(response.data.return);
        } else {
          resolve(null);
        }
      });
    })
  },
  async changeStore({ commit, dispatch }, store) {
    return new Promise((resolve) => {
      commit('setSelectedStore', store);
      dispatch('updateConfig').then(() => {
        commit('setFirstLoad', false);
        commit('setLoadingFooter', true);
        commit('setLoadingTabs', true);
        commit('setLoadingBanners', 0);
        commit('cart/setLoadingCart', true, { root: true });
        resolve(true);
      });
    });
  },
  async getStorePickup({ commit, rootGetters }) {
    commit('setLoadingStores', true);
    return new Promise((resolve) => {
      WsCalls.callMethodWS('GET', 'storePickup', rootGetters['main/getConfig']).then(function (response) {
        if (response.data.cod == 100 && response.data.return) {
          commit('setStorePickup', response.data.return);
        } else {
          commit('setStorePickup', []);
        }
        commit('setLoadingStores', false);
        resolve(true);
      });
    })
  },
  async storeTimes({ rootGetters }, id) {
    return new Promise((resolve) => {
      WsCalls.callMethodWS('GET', 'storePickup', rootGetters['main/getConfig'], id).then(function (response) {
        let horarios = null;
        if (response.data.return != null) {
          horarios = response.data.return.reduce((agrupado, objeto) => {
            const date = objeto.date;
            if (!agrupado[date]) {
              agrupado[date] = [];
            }
            agrupado[date].push(objeto);
            return agrupado;
          }, {});
          horarios = Object.entries(horarios).map(([date, times]) => ({ date, times }));
        }
        resolve(horarios);
      });
    })
  },
  async getTabs({ commit, rootGetters }) {
    return new Promise((resolve) => {
      WsCalls.callMethodWS('GET', 'userTabs', rootGetters['main/getConfig'], null).then(function (response) {
        if (response.data.cod == 100 && response.data.return) {
          commit('setTabs', response.data.return);
          response.data.return.forEach(element => {
            if (element.imghash != '') {
              WsCalls.callMethodWS('IMAGE', 'servicesImage', rootGetters['main/getConfig'], element.imghash).then(function (retorno) {
                if (retorno.data.cod == 404) {
                  commit('setTabImage', { id: element.id, type: element.type, image: 'no-image' });
                } else {
                  commit('setTabImage', { id: element.id, type: element.type, image: URL.createObjectURL(retorno.data) });
                }
              });
            } else {
              commit('setTabImage', { id: element.id, type: element.type, image: 'no-image' });
            }
          });
        } else {
          commit('setTabs', []);
        }
        commit('setLoadingTabs', false);
        resolve(true);
      });
    })
  },
  async getContainers({ commit, rootGetters }) {
    return new Promise((resolve) => {
      WsCalls.callMethodWS('GET', 'userContainers', rootGetters['main/getConfig'], null).then(function (response) {
        if (response.data.cod == 100 && response.data.return) {
          commit('setContainers', response.data.return);
        } else {
          commit('setContainers', []);
        }
        commit('setLoadingContainers', false);
        resolve(true);
      });
    })
  },
  async loadPayments({ commit, rootGetters }, parametros) {
    return new Promise((resolve) => {
      let config = JSON.parse(JSON.stringify(rootGetters['main/getConfig']));
      if (parametros.destiny_type == 0) {
        config.store = parametros.store;
      }
      WsCalls.callMethodWS('GET', 'paymentMethod', config, parametros.destiny_type).then(function (response) {
        if (response.data.cod == 100 && response.data.return) {
          commit('setPayments', response.data.return);
          response.data.return.forEach(element => {
            WsCalls.callMethodWS('IMAGE', 'paymentMethodImage', rootGetters['main/getConfig'], element.id).then(function (retorno) {
              if (retorno.data.cod == 404) {
                commit('setPaymentImage', { id: element.id, image: 'no-image' });
              } else {
                commit('setPaymentImage', { id: element.id, image: URL.createObjectURL(retorno.data) });
              }
            });
          });
        } else {
          commit('setPayments', []);
        }
        resolve(true);
      });
    })
  },
  async getSubCategoriesMenu({ state, commit, rootGetters }, id) {
    return new Promise((resolve) => {
      let categories = state.tabs.filter(category => category.type == 3);
      if (categories != undefined) {
        categories = categories.find(category => category.id == id).subcategories;
      } else {
        categories = undefined;
      }
      if (categories == undefined) {
        WsCalls.callMethodWS('GET', 'userSubcat', rootGetters['main/getConfig'], id, { count: 1 }).then(function (response) {
          if (response.data.cod == 100 && response.data.return) {
            commit('setSubCategories', { "id": id, "subcategories": response.data.return.subcategory });
          }
          commit('setLoadingSubCategories', false);
          resolve(true);
        });
      }
    })
  },
  async getSubCategories({ state, commit, rootGetters }, id) {
    return new Promise((resolve) => {
      let categories = state.tabs.filter(category => category.type == 3);
      if (categories != undefined) {
        categories = categories.find(category => category.id == id).subcategories;
      } else {
        categories = undefined;
      }
      if (categories == undefined) {
        commit('setLoadingSubCategories', true);
        WsCalls.callMethodWS('GET', 'userSubcat', rootGetters['main/getConfig'], id, { count: 1 }).then(function (response) {
          if (response.data.cod == 100 && response.data.return) {
            commit('setSubCategories', { "id": id, "subcategories": response.data.return.subcategory });
          }
          commit('setLoadingSubCategories', false);
          resolve(true);
        });
      }
    })
  },
  async getBanners({ commit, rootGetters }) {
    return new Promise((resolve) => {
      commit('setLoadingBanners', 0);
      WsCalls.callMethodWS('GET', 'banners', rootGetters['main/getConfig'], null).then(function (response) {
        if (response.data.cod == 100 && response.data.return) {
          commit('setCarouselBanners', response.data.return);
          if(response.data.return.length > 0){
            response.data.return.forEach(element => {
              WsCalls.callMethodWS('IMAGE', 'bannerImage', rootGetters['main/getConfig'], element.imghash).then(function (retorno) {
                if (retorno.data.cod == 404) {
                  commit('setBannerImage', { imghash: element.imghash, image: 'no-image' });
                } else {
                  commit('setBannerImage', { imghash: element.imghash, image: URL.createObjectURL(retorno.data) });
                }
                commit('setLoadingBanners', 1);
              });
            });
          } else {
            commit('setLoadingBanners', -1);
          }
        } else {
          commit('setCarouselBanners', []);
          commit('setLoadingBanners', -1);
        }
        resolve(true);
      });
    });
  },
  async getFixedBanners({ commit, rootGetters }) {
    return new Promise((resolve) => {
      commit('setLoadingFixedBanners', true);
      WsCalls.callMethodWS('GET', 'fixedBanners', rootGetters['main/getConfig'], null).then(function (response) {
        if (response.data.cod == 100 && response.data.return) {
          let banners = [
            {
              "titulo": response.data.return.banner_name1,
              "imghash": response.data.return.banner_imghash1,
              "url": response.data.return.banner_url1,
              "target": 0
            },
            {
              "titulo": response.data.return.banner_name2,
              "imghash": response.data.return.banner_imghash2,
              "url": response.data.return.banner_url2,
              "target": 0
            },
            {
              "titulo": response.data.return.banner_name3,
              "imghash": response.data.return.banner_imghash3,
              "url": response.data.return.banner_url3,
              "target": 0
            }
          ];
          commit('setFixedBanners', banners);
          banners.forEach(element => {
            WsCalls.callMethodWS('IMAGE', 'bannerImage', rootGetters['main/getConfig'], element.imghash).then(function (retorno) {
              if (retorno.data.cod == 404) {
                commit('setFixedBannerImage', { imghash: element.imghash, image: 'no-image' });
              } else {
                commit('setFixedBannerImage', { imghash: element.imghash, image: URL.createObjectURL(retorno.data) });
              }
              commit('setLoadingFixedBanners', false);
            });
          });
        } else {
          commit('setFixedBanners', []);
        }
        resolve(true);
      });
    });
  },
  async savedValue({ rootGetters, commit }) {
    return new Promise((resolve) => {
      WsCalls.callMethodWS('GET', 'savedValue', rootGetters['main/getConfig']).then(function (response) {
        if (response.data.cod == 100 && response.data.return) {
          commit('setPoupometro', response.data.return.value);
        } else {
          commit('setPoupometro', 0);
        }
        commit('setLoadingPoupometro', false);
        resolve(true);
      });
    });
  },
  async live({ rootGetters }) {
    return new Promise((resolve) => {
      if(rootGetters['main/getConfig'].isu > 0){
        WsCalls.callMethodWS('POST', 'live', rootGetters['main/getConfig']).then(function () {
          resolve(true);
        });
      } else {
        resolve(true);
      }
    });
  },
  async clearNPS({ commit }) {
    commit('clearNPS');
  },
  async loadOnlinePayments({ commit, rootGetters }) {
    return new Promise((resolve) => {
      WsCalls.callMethodWS('GET', 'onlinePaymentFlags', rootGetters['main/getConfig'], null).then(function (response) {
        if (response.data.cod == 100 && response.data.return) {
          commit('setOnlinePayments', response.data.return);
          response.data.return.forEach(element => {
            WsCalls.callMethodWS('IMAGE', 'paymentOnlineImage', rootGetters['main/getConfig'], element.id).then(function (retorno) {
              if (retorno.data.cod == 404) {
                commit('setOnlinePaymentIcon', { id: element.id, image: 'no-image' });
              } else {
                commit('setOnlinePaymentIcon', { id: element.id, image: URL.createObjectURL(retorno.data) });
              }
            });
          });
          response.data.return.forEach(element => {
            WsCalls.callMethodWS('IMAGE', 'paymentOnlineImage', rootGetters['main/getConfig'], "c"+element.id).then(function (retorno) {
              if (retorno.data.cod == 404) {
                commit('setOnlinePaymentImage', { id: element.id, image: 'no-image' });
              } else {
                commit('setOnlinePaymentImage', { id: element.id, image: URL.createObjectURL(retorno.data) });
              }
            });
          });
        } else {
          commit('setOnlinePayments', []);
        }
        resolve(true);
      });
    })
  },
}

// mutations
const mutations = {
  setFirstLoad(state, firstLoad) {
    state.firstLoad = firstLoad;
  },
  setSelectedStore(state, selectedStore) {
    state.selectedStore = selectedStore;
  },
  setTabs(state, tabs) {
    state.tabs = tabs;
  },
  setContainers(state, containers) {
    state.containers = containers;
  },
  setStorePickup(state, storePickup) {
    state.storePickup = storePickup;
  },
  setSubCategories(state, { id, subcategories }) {
    let categories = state.tabs.filter(category => category.type == 3);
    categories = categories.find(category => category.id == id);
    if (categories != null) {
      categories.subcategories = subcategories;
    }
  },
  setCarouselBanners(state, carousel_banners) {
    state.carousel_banners = carousel_banners;
  },
  setBannerImage(state, { imghash, image }) {
    var carousel_banners = state.carousel_banners.find(p => p.imghash == imghash);
    if (carousel_banners != undefined) {
      carousel_banners.image = image;
    }
  },
  setFixedBanners(state, banners) {
    state.banners = banners;
  },
  setFixedBannerImage(state, { imghash, image }) {
    var banners = state.banners.find(p => p.imghash == imghash);
    if (banners != undefined) {
      banners.image = image;
    }
  },
  setTabImage(state, { id, type, image }) {
    var tabs = state.tabs.find(p => (p.id == id && p.type == type));
    if (tabs != undefined) {
      tabs.image = image;
    }
  },
  setCities(state, cities) {
    state.cities = cities;
  },
  setStores(state, stores) {
    state.stores = stores;
  },
  setStoreConfig(state, storeConfig) {
    state.storeConfig = storeConfig;
  },
  setPayments(state, payments) {
    state.payments = payments;
  },
  setOnlinePayments(state, online_payments) {
    state.online_payments = online_payments;
  },
  setOnlinePaymentImage(state, { id, image }) {
    let online_payments = state.online_payments.find(p => p.id == id);
    if (online_payments != null) {
      online_payments.image = image;
    }
  },
  setOnlinePaymentIcon(state, { id, image }) {
    let online_payments = state.online_payments.find(p => p.id == id);
    if (online_payments != null) {
      online_payments.icon = image;
    }
  },
  setPaymentImage(state, { id, image }) {
    let payments = state.payments.find(p => p.id == id);
    if (payments != null) {
      payments.image = image;
    }
  },
  setLogoImage(state, image) {
    state.logoImage = image;
  },
  setStoreImage(state, image) {
    state.storeImage = image;
  },
  setLoadingTabs(state, status) {
    state.loadingTabs = status;
  },
  setLoadingSubCategories(state, status) {
    state.loadingSubCategories = status;
  },
  setLoadingBanners(state, status) {
    state.loadingBanners = status;
  },
  setLoadingFixedBanners(state, status) {
    state.loadingFixedBanners = status;
  },
  setLoadingContainers(state, status) {
    state.loadingContainers = status;
  },
  setLoadingStores(state, status) {
    state.loadingStores = status;
  },
  setLoadingText(state, status) {
    state.loadingText = status;
  },
  setLoadingFooter(state, status) {
    state.loadingFooter = status;
  },
  setPoupometro(state, poupometro) {
    state.poupometro = poupometro;
  },
  setLoadingPoupometro(state, status) {
    state.loadingPoupometro = status;
  },
  clearNPS(state) {
    state.storeConfig.is_nps = null;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}